import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78fc4809"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "填充颜色：", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "边框样式：", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("实线边框")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("虚线边框")
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "边框颜色：", -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "边框粗细：", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("-")

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElement, PPTElementOutline, TableCell } from '@/types/slides'
import emitter, { EmitterEvents } from '@/utils/emitter'
import { WEB_FONTS } from '@/configs/font'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from '../common/ColorButton.vue'
import TextColorButton from '../common/TextColorButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiStylePanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { richTextAttrs, availableFonts, activeElementList } = storeToRefs(useMainStore())

const { addHistorySnapshot } = useHistorySnapshot()

const updateElement = (id: string, props: Partial<PPTElement>) => {
  slidesStore.updateElement({ id, props })
  addHistorySnapshot()
}

const fontSizeOptions = [
  '12px', '14px', '16px', '18px', '20px', '22px', '24px', '28px', '32px',
  '36px', '40px', '44px', '48px', '54px', '60px', '66px', '72px', '76px',
  '80px', '88px', '96px', '104px', '112px', '120px',
]

const fill = ref('#fff')
const outline = ref<PPTElementOutline>({
  width: 0,
  color: '#fff',
  style: 'solid',
})

// 批量修改填充色（表格元素为单元格填充、音频元素为图标颜色）
const updateFill = (value: string) => {
  for (const el of activeElementList.value) {
    if (
      el.type === 'text' ||
      el.type === 'shape' ||
      el.type === 'chart'
    ) updateElement(el.id, { fill: value })

    if (el.type === 'table') {
      const data: TableCell[][] = JSON.parse(JSON.stringify(el.data))
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].length; j++) {
          const style = data[i][j].style || {}
          data[i][j].style = { ...style, backcolor: value }
        }
      }
      updateElement(el.id, { data })
    }

    if (el.type === 'audio') updateElement(el.id, { color: value })
  }
  fill.value = value
}

// 修改边框/线条样式
const updateOutline = (outlineProps: Partial<PPTElementOutline>) => {

  for (const el of activeElementList.value) {
    if (
      el.type === 'text' ||
      el.type === 'image' ||
      el.type === 'shape' ||
      el.type === 'table' ||
      el.type === 'chart'
    ) {
      const outline = el.outline || { width: 2, color: '#000', style: 'solid' }
      const props = { outline: { ...outline, ...outlineProps } }
      updateElement(el.id, props)
    }

    if (el.type === 'line') updateElement(el.id, outlineProps)
  }
  outline.value = { ...outline.value, ...outlineProps }
}

// 修改文字样式
const updateFontStyle = (command: string, value: string) => {
  for (const el of activeElementList.value) {
    if (el.type === 'text' || (el.type === 'shape' && el.text?.content)) {
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { target: el.id, action: { command, value } })
    }
    if (el.type === 'table') {
      const data: TableCell[][] = JSON.parse(JSON.stringify(el.data))
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].length; j++) {
          const style = data[i][j].style || {}
          data[i][j].style = { ...style, [command]: value }
        }
      }
      updateElement(el.id, { data })
    }
    if (el.type === 'latex' && command === 'color') {
      updateElement(el.id, { color: value })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_SelectOptGroup = _resolveComponent("SelectOptGroup")!
  const _component_IconAddText = _resolveComponent("IconAddText")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_IconText = _resolveComponent("IconText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IconHighLight = _resolveComponent("IconHighLight")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")!
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: fill.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = value => updateFill(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: fill.value,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: outline.value.style,
        onChange: _cache[1] || (_cache[1] = value => updateOutline({ style: value as 'solid' | 'dashed' }))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectOption, { value: "solid" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "dashed" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: outline.value.color,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = value => updateOutline({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: outline.value.color || '#000',
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createVNode(_component_InputNumber, {
        value: outline.value.width,
        onChange: _cache[3] || (_cache[3] = value => updateOutline({ width: value as number })),
        style: {"flex":"3"}
      }, null, 8, ["value"])
    ]),
    _createVNode(_component_Divider),
    _createVNode(_component_InputGroup, {
      compact: "",
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Select, {
          style: {"flex":"3"},
          value: _unref(richTextAttrs).fontname,
          onChange: _cache[4] || (_cache[4] = value => updateFontStyle('fontname', value as string))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_IconFontSize)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_SelectOptGroup, { label: "系统字体" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFonts), (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ fontFamily: font.value })
                      }, _toDisplayString(font.label), 5)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_SelectOptGroup, { label: "在线字体" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEB_FONTS), (font) => {
                  return (_openBlock(), _createBlock(_component_SelectOption, {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(font.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_Select, {
          style: {"flex":"2"},
          value: _unref(richTextAttrs).fontsize,
          onChange: _cache[5] || (_cache[5] = value => updateFontStyle('fontsize', value as string))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_IconAddText)
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fontSizeOptions, (fontsize) => {
              return _createVNode(_component_SelectOption, {
                key: fontsize,
                value: fontsize
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(fontsize), 1)
                ]),
                _: 2
              }, 1032, ["value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _unref(richTextAttrs).color,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = value => updateFontStyle('color', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字颜色"
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: _unref(richTextAttrs).color,
                  style: {"flex":"3"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconText)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: _unref(richTextAttrs).backcolor,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = value => updateFontStyle('backcolor', value))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Tooltip, {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: "文字高亮"
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: _unref(richTextAttrs).backcolor,
                  style: {"flex":"3"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconHighLight)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay"])
          ]),
          _: 1
        }),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "增大字号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "font-size-btn",
              style: {"flex":"2"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (updateFontStyle('fontsize-add', '2')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFontSize),
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "减小字号"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "font-size-btn",
              style: {"flex":"2"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (updateFontStyle('fontsize-reduce', '2')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFontSize),
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_RadioGroup, {
      class: "row",
      "button-style": "solid",
      value: _unref(richTextAttrs).align,
      onChange: _cache[10] || (_cache[10] = e => updateFontStyle('align', e.target.value))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: "left",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "居中"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: "center",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextCenter)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              value: "right",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})